import { render, staticRenderFns } from "./knowledgeMenu.vue?vue&type=template&id=4ad52e7c&scoped=true&"
import script from "./knowledgeMenu.vue?vue&type=script&lang=js&"
export * from "./knowledgeMenu.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeMenu.vue?vue&type=style&index=0&id=4ad52e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad52e7c",
  null
  
)

export default component.exports